import React, { useEffect } from 'react'
import { Map, List, fromJS } from 'immutable'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { ftRemoveLocalStorage, ftSetLocalStorage } from '../../lib/common'
import { compressToUTF16 } from 'lz-string'
import { isSame } from '../WidgetBuilder/UI/isSame'
import { getParentIdInModal } from '../../constants/toUnits'
import { setElemValue } from '../../store/project/setElemValue'
import { processCondRules } from '../../store/project/processCondRules'
import { processButtonAction } from '../../store/project/processButtonAction'
import { getState } from '../../lib/processPortalRules'
import _ from 'lodash'
import { getMappingCount } from '../../constants/getMappingCount'

function setCookie(name, value) {
  document.cookie = name + '=' + (value || '') + '; path=/'
}

export const SESS_COOKIE_KEY = 'ftsck'
export const getSessionProjectLocaKey = (projectID) => `${projectID}:${SESS_COOKIE_KEY}`
export const getProjectLocalKey = (projectID) => `${projectID}:lu`

const PLAYER_STATUS = {
  [-1]: 'UNSTARTED',
  0: 'ENDED',
  1: 'PLAYING',
  2: 'PAUSED',
  3: 'BUFFERING',
  5: 'CUED',
}

const toTime = (num) => Number(num).toFixed(2)

export const VideoEventsAPI = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const hasYoutubeElements = useSelector((state) =>
    state
      .getIn(['pages', state.get('page'), 'Props', 'elements'], Map())
      .merge(state.getIn(['project', 'Settings', 'elements'], Map()))
      .find((element) => element.get('type') === 'YouTube')
  )

  useEffect(() => {
    if (!hasYoutubeElements) return
    let players = {}
    function onYouTubeIframeAPIReady(i = 0) {
      if (typeof window.YT === 'undefined' || typeof window?.YT?.Player === 'undefined') {
        return false
      }
      const state = store.getState()
      const appState = getState(state)
      const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
      let list = []
      const elemParentUID = {}
      const elemParent = {}
      const elemHash = {}
      const timeoutList = {}
      const PageUID = state
        .getIn(['project', 'Pages'], List())
        .find((page) => page.get('_id') === state.get('page'))
        ?.get?.('uid')
      state.getIn(['project', 'Settings', 'elements'], Map()).map((elem, id) => {
        if (elem.get('type') === 'YouTube') {
          list.push(id)
          elemParentUID[id] = 'project'
          elemParent[id] = getParentIdInModal(state, elem.get('parent'), true)
          elemHash[id] = elem
        }
      })
      if (PageUID) {
        state.getIn(['pages', state.get('page'), 'Props', 'elements'], Map()).map((elem, id) => {
          if (elem.get('type') === 'YouTube') {
            list.push(id)
            elemParentUID[id] = PageUID
            elemParent[id] = getParentIdInModal(state, elem.get('parent'), true)
            elemHash[id] = elem
          }
        })
      }
      _.map(list, (id) => {
        function onPlayerReady(event) {
          // event.target.playVideo();
        }
        const getOnPlayerReady = (index) => (event) => {
          // event.target.playVideo();
        }
        function onPlayerStateChange(event) {
          const status = PLAYER_STATUS[event.data]
          const elem = elemHash[id]
          const postID = elemParentUID[id] === 'project' ? elemParent[id] : elemParentUID[id]

          const onPlay = elem.getIn(['props', 'onPlay'], List())
          const onPause = elem.getIn(['props', 'onPause'], List())
          const onComplete = elem.getIn(['props', 'onComplete'], List())
          dispatch(setElemValue([`${id}-status`], status, 'FormField', [postID], true))
          if (players[id]) {
            dispatch(
              setElemValue([`${id}-time`], toTime(players[id].playerInfo?.currentTime), 'FormField', [postID], true)
            )
          }
          dispatch(processCondRules(id, null, [postID, `${id}-status`], null))
          if (event.data === 1 && !timeoutList[id]) {
            const tick = () => {
              if (players[id]) {
                dispatch(
                  setElemValue([`${id}-time`], toTime(players[id].playerInfo?.currentTime), 'FormField', [postID], true)
                )
                dispatch(processCondRules(id, null, [postID, `${id}-time`], null))
              } else {
                dispatch(setElemValue([`${id}-time`], 0, 'FormField', [postID], true))
                dispatch(processCondRules(id, null, [postID, `${id}-time`], null))
              }
            }
            timeoutList[id] = setInterval(tick, 5000)
          } else if (timeoutList[id]) {
            clearInterval(timeoutList[id])
            timeoutList[id] = null
          }
          let action = null
          if (event.data === 1) {
            action = onPlay
          }
          if (event.data === 2) {
            action = onPause
          } else if (
            event.data === 0 &&
            players[id] &&
            players[id].playerInfo?.duration === Math.ceil(players[id].playerInfo?.currentTime)
          ) {
            action = onComplete
          }
          if (action) {
            dispatch(processButtonAction(action, id, false, null))
          }
        }
        const getOnPlayerStateChange = (index) => (event) => {
          const status = PLAYER_STATUS[event.data]
          const elem = elemHash[id]
          const postID = elemParentUID[id] === 'project' ? elemParent[id] : elemParentUID[id]

          const onPlay = elem.getIn(['props', 'onPlay'], List())
          const onPause = elem.getIn(['props', 'onPause'], List())
          const onComplete = elem.getIn(['props', 'onComplete'], List())
          dispatch(setElemValue([`${id}-status`, String(index)], status, 'FormField', [postID, elemParent[id]], true))
          const playerID = `${id}_${index}`
          if (players[playerID]) {
            dispatch(
              setElemValue(
                [`${id}-time`, String(index)],
                toTime(players[playerID].playerInfo?.currentTime),
                'FormField',
                [postID, elemParent[id]],
                true
              )
            )
          }
          dispatch(processCondRules(id, null, [postID, elemParent[id], `${id}-status`, String(index)], index))

          if (event.data === 1 && !timeoutList[playerID]) {
            const tick = () => {
              if (players[playerID]) {
                dispatch(
                  setElemValue(
                    [`${id}-time`, String(index)],
                    toTime(players[playerID].playerInfo?.currentTime),
                    'FormField',
                    [postID, elemParent[id]],
                    true
                  )
                )
                dispatch(processCondRules(id, null, [postID, elemParent[id], `${id}-time`, String(index)], index))
                dispatch(processButtonAction(onPlay, id, true, index))
              } else {
                dispatch(setElemValue([`${id}-time`, String(index)], 0, 'FormField', [postID, elemParent[id]], true))
                dispatch(processCondRules(id, null, [postID, elemParent[id], `${id}-time`, String(index)], index))
                dispatch(processButtonAction(onPlay, id, true, index))
              }
            }
            tick()
            timeoutList[playerID] = setInterval(tick, 5000)
          } else if (event.data !== 1 && timeoutList[playerID]) {
            clearInterval(timeoutList[playerID])
            timeoutList[playerID] = null
          }
          let action = null
          if (event.data === 1) {
            action = onPlay
          }
          if (event.data === 2) {
            action = onPause
          } else if (
            event.data === 0 &&
            players[playerID] &&
            players[playerID].playerInfo?.duration === Math.ceil(players[playerID].playerInfo?.currentTime)
          ) {
            action = onComplete
            clearInterval(timeoutID)
          }
          if (action) {
            players[playerID] &&
              console.log(
                id,
                ' >>> ',
                event.data,
                players[playerID].playerInfo?.duration,
                Math.ceil(players[playerID].playerInfo?.currentTime)
              )
            dispatch(processButtonAction(action, id, true, index))
          }
        }
        const isRepeat = elemParentUID[id] !== 'project' && _.includes(RepeatedStripsID, elemParent[id])
        if (isRepeat) {
          let stripState = _.get(appState, [PageUID, elemParent[id]], {})
          const allowEmpty = state.getIn(
            ['pages', state.get('page'), 'Props', 'elements', elemParent[id], 'props', 'allowEmptyRow'],
            true
          )
          let count = getMappingCount(stripState)
          if (!count && allowEmpty) {
            count = 1
          }
          _.times(count, (index) => {
            const el = document.getElementById(`${id}_${index}`)
            if (!el && i < 4) {
              return setTimeout(onYouTubeIframeAPIReady, 200, i + 1)
            }
            if (timeoutList[`${id}_${index}`]) {
              clearInterval(timeoutList[`${id}_${index}`])
            }
            let player = new YT.Player(`${id}_${index}`, {
              events: {
                onReady: getOnPlayerReady(index),
                onStateChange: getOnPlayerStateChange(index),
              },
              playerVars: {
                origin: window.location.origin,
              },
            })
            players[`${id}_${index}`] = player
          })
        } else {
          if (timeoutList[id]) {
            clearInterval(timeoutList[id])
          }
          let player = new YT.Player(id, {
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange,
            },
            playerVars: {
              origin: window.location.origin,
            },
          })
          players[id] = player
        }
      })
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady

    let tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    let scripts = document.getElementsByTagName('script')
    let isLoaded = false
    Array.from(scripts).forEach((node) => {
      if (node.src === 'https://www.youtube.com/iframe_api') {
        isLoaded = true
      }
    })
    if (!isLoaded) {
      let firstScriptTag = scripts[0]
      if (firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      } else {
        document.head.appendChild(tag)
      }
    } else {
      document.head.appendChild(tag)
    }
  }, [hasYoutubeElements])

  return null
}
export const ProjectPersistSessionParameter = () => {
  const projectID = useSelector((state) => state.getIn(['project', 'URL']))
  const params = useSelector((state) => state.get('params', Map()), isSame)
  const syncParams = useSelector((state) => state.getIn(['project', 'Settings', 'ui', 'syncParams'], false))

  React.useEffect(() => {
    if (syncParams) {
      let sessCookie = String(
        String(document.cookie)
          .split('; ')
          .find((row) => row.startsWith(SESS_COOKIE_KEY))
      ).split('=')[1]
      if (!sessCookie) {
        setCookie(SESS_COOKIE_KEY, projectID)
        ftRemoveLocalStorage(getSessionProjectLocaKey(projectID))
      }
      ftSetLocalStorage(getSessionProjectLocaKey(projectID), compressToUTF16(JSON.stringify(params.toJS())))
    }
  }, [params, syncParams])

  return null
}
